import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { FormControl } from '@angular/forms';
import { MatSliderChange } from '@angular/material/slider';

@Component({
    selector: 'formly-slider-type',
    template: `
    <div class="slider-wrapper">
      <label class="slider-label">{{ to.label }}</label>
      <mat-slider
        [min]="to.min || 0"
        [max]="to.max || 100"
        [step]="to.step || 1"
        discrete
       #ngSlider><input matSliderThumb [formControl]="control" (input)="onSliderChange({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value})" #ngSliderThumb="matSliderThumb" /></mat-slider>
      <div class="slider-value">{{ control.value }}</div>
    </div>
  `,
    styles: [`
    .slider-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 6px 0;
      font-family: 'Poppins', sans-serif !important;
    }

    .slider-label {
      font-size: 12px;
      font-weight: 600;
      color: #101D42;
      flex: 1;
      margin-right: 8px;
    }

    mat-slider {
      flex: 3;
    }

    .slider-value {
      font-size: 12px;
      font-weight: 500;
      color: #555;
      width: 40px;
      text-align: right;
    }
  `],
    standalone: false
})
export class SliderTypeComponent extends FieldType implements OnInit {

  // ✅ Safely cast AbstractControl → FormControl
  get control(): FormControl {
    return this.formControl as FormControl;
  }

  ngOnInit() {
    // Handle value changes from Formly
    this.control.valueChanges.subscribe(value => {
      if (this.to?.['onChange']) {
        this.to['onChange'](value, this.field);
      }
    });
  }

  // ✅ Properly handle MatSliderChange
  onSliderChange(event: MatSliderChange): void {
    const value = event.value ?? 0; // safely handle null
    this.control.setValue(value, { emitEvent: true });
  }
}
